import { View } from 'react-native'
import { useTranslation } from 'react-i18next'
import Page from '@shell/Page'
import Header from '@ui/elements/Header'
import DiscountOption from '@order/DiscountOption'

export default function DevDiscountsPage() {
  const { t } = useTranslation(['ui', 'modals', 'order'])
  const text = 'order:discounts'

  return (
    <Page stage="order">
      <Header
        title={t(`${text}.header.title`)}
        desc={t(`${text}.header.desc`)}
      />
      <View className="flex flex-1 flex-col gap-8 px-8 pb-8">
        <DiscountOption
          option={'promotion'}
          status="attention"
          info="Action"
          onPress={() => console.log('promotion')}
        />
        <DiscountOption
          option={'credit'}
          status="default"
          info="100€"
          onPress={() => console.log('credit')}
        />
        <DiscountOption
          option={'coupon'}
          status="active"
          info={'2'}
          onPress={() => console.log('coupon')}
        />
        <DiscountOption
          option={'gift-card'}
          status="disabled"
          onPress={() => console.log('gift-card')}
        />
        <DiscountOption
          option={'referral'}
          status="default"
          onPress={() => console.log('referral')}
        />
      </View>
    </Page>
  )
}
